var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"culture"},[_c('g-hero',{attrs:{"content":_vm.content}}),_c('culture-team',{attrs:{"content":_vm.content.values}}),_c('culture-action',{staticClass:"culture__action",attrs:{"content":_vm.content.actions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }